(function () {

  function initHeroBanner(root) {

    const banners =
      root &&
      root.matches?.('[data-hero-banner]')
        ? [root]
        : Array.from(
            document.querySelectorAll(
              '[data-hero-banner]'
            )
          );


    banners.forEach(
      function (banner) {

        if (
          banner.dataset
            .heroBannerInitialized ===
          'true'
        ) {
          return;
        }


        banner.dataset
          .heroBannerInitialized =
          'true';


        const slides =
          Array.from(
            banner.querySelectorAll(
              '[data-hero-slide]'
            )
          );


        if (!slides.length) {
          return;
        }


        const dots =
          Array.from(
            banner.querySelectorAll(
              '[data-hero-dot]'
            )
          );


        const prevButton =
          banner.querySelector(
            '[data-hero-prev]'
          );


        const nextButton =
          banner.querySelector(
            '[data-hero-next]'
          );


        const autoplay =
          banner.dataset.autoplay ===
          'true';


        const slideDuration =
          Math.max(
            1000,
            Number(
              banner.dataset.slideDuration ||
              5
            ) * 1000
          );


        const transitionDuration =
          Math.max(
            300,
            Number(
              banner.dataset.transitionDuration ||
              1000
            )
          );


        let currentIndex =
          slides.findIndex(
            function (slide) {

              return slide.classList.contains(
                'is-active'
              );

            }
          );


        if (currentIndex < 0) {
          currentIndex = 0;
        }


        let timer = null;

        let transitioning = false;


        /* =================================================
           UPDATE DOTS
        ================================================== */

        function updateDots() {

          dots.forEach(
            function (dot, index) {

              const active =
                index === currentIndex;


              dot.classList.toggle(
                'is-active',
                active
              );


              dot.setAttribute(
                'aria-current',
                active
                  ? 'true'
                  : 'false'
              );

            }
          );

        }


        /* =================================================
           RESET SLIDE
        ================================================== */

        function resetSlide(slide) {

          if (!slide) {
            return;
          }


          slide.classList.remove(
            'is-next',
            'is-compressing'
          );


          slide.style.clipPath = '';

          slide.style.transition = '';

          slide.style.opacity = '';

          slide.style.visibility = '';


          const media =
            slide.querySelector(
              '.hero-banner__media'
            );


          if (media) {

            media.style.transform = '';

            media.style.transformOrigin = '';

            media.style.transition = '';

          }

        }


        /* =================================================
           STOP AUTOPLAY
        ================================================== */

        function stopAutoplay() {

          if (timer !== null) {

            window.clearTimeout(
              timer
            );


            timer = null;

          }

        }


        /* =================================================
           START AUTOPLAY
        ================================================== */

        function startAutoplay() {

          stopAutoplay();


          if (
            !autoplay ||
            slides.length < 2 ||
            transitioning
          ) {
            return;
          }


          timer =
            window.setTimeout(
              function () {

                goToSlide(
                  currentIndex + 1
                );

              },
              slideDuration
            );

        }


        /* =================================================
           FINISH TRANSITION
        ================================================== */

        function finishTransition(
          currentSlide,
          nextSlide,
          nextIndex
        ) {

          currentSlide.classList.remove(
            'is-active'
          );


          resetSlide(
            currentSlide
          );


          resetSlide(
            nextSlide
          );


          nextSlide.classList.add(
            'is-active'
          );


          currentIndex =
            nextIndex;


          transitioning =
            false;


          updateDots();

          startAutoplay();

        }


        /* =================================================
           COMPRESS UP

           Current slide sits above next slide.

           Current slide:
           full height
                ↓
           bottom edge travels upward
                ↓
           image becomes vertically compressed
           toward the top
                ↓
           next slide is revealed underneath
        ================================================== */

        function runCompressUp(
          currentSlide,
          nextSlide,
          nextIndex
        ) {

          nextSlide.classList.add(
            'is-next'
          );


          currentSlide.classList.add(
            'is-compressing'
          );


          /*
           * Initial outgoing state.
           */

          currentSlide.style.clipPath =
            'inset(0 0 0% 0)';


          currentSlide.style.transition =
            'none';


          const currentMedia =
            currentSlide.querySelector(
              '.hero-banner__media'
            );


          if (currentMedia) {

            currentMedia.style.transformOrigin =
              'top center';


            currentMedia.style.transform =
              'scaleY(1)';


            currentMedia.style.transition =
              'none';

          }


          /*
           * Force browser to render
           * the starting state.
           */

          currentSlide.offsetHeight;


          /*
           * Set transitions after initial state
           * has been rendered.
           */

          currentSlide.style.transition =
            `
              clip-path
              ${transitionDuration}ms
              cubic-bezier(0.76, 0, 0.24, 1)
            `;


          if (currentMedia) {

            currentMedia.style.transition =
              `
                transform
                ${transitionDuration}ms
                cubic-bezier(0.76, 0, 0.24, 1)
              `;

          }


          /*
           * Start transition.
           */

          requestAnimationFrame(
            function () {

              requestAnimationFrame(
                function () {

                  /*
                   * Bottom moves upward.
                   *
                   * We stop slightly before 100%
                   * so the final compression is
                   * still visually noticeable.
                   */

                  currentSlide.style.clipPath =
                    'inset(0 0 98% 0)';


                  /*
                   * Compress the actual image
                   * toward its top edge.
                   */

                  if (currentMedia) {

                    currentMedia.style.transform =
                      'scaleY(0.06)';

                  }

                }
              );

            }
          );


          window.setTimeout(
            function () {

              finishTransition(
                currentSlide,
                nextSlide,
                nextIndex
              );

            },
            transitionDuration + 40
          );

        }


        /* =================================================
           CHANGE SLIDE
        ================================================== */

        function goToSlide(index) {

          if (
            transitioning ||
            slides.length < 2
          ) {
            return;
          }


          let nextIndex =
            Number(index);


          if (
            Number.isNaN(
              nextIndex
            )
          ) {
            return;
          }


          if (nextIndex < 0) {

            nextIndex =
              slides.length - 1;

          }


          if (
            nextIndex >=
            slides.length
          ) {

            nextIndex = 0;

          }


          if (
            nextIndex ===
            currentIndex
          ) {
            return;
          }


          transitioning = true;


          stopAutoplay();


          const currentSlide =
            slides[currentIndex];


          const nextSlide =
            slides[nextIndex];


          /*
           * Clean next slide before using it.
           */

          resetSlide(
            nextSlide
          );


          /*
           * Start compression.
           */

          runCompressUp(
            currentSlide,
            nextSlide,
            nextIndex
          );

        }


        /* =================================================
           NEXT BUTTON
        ================================================== */

        if (nextButton) {

          nextButton.addEventListener(
            'click',
            function () {

              goToSlide(
                currentIndex + 1
              );

            }
          );

        }


        /* =================================================
           PREVIOUS BUTTON
        ================================================== */

        if (prevButton) {

          prevButton.addEventListener(
            'click',
            function () {

              goToSlide(
                currentIndex - 1
              );

            }
          );

        }


        /* =================================================
           DOTS
        ================================================== */

        dots.forEach(
          function (dot) {

            dot.addEventListener(
              'click',
              function () {

                const index =
                  Number(
                    dot.dataset.index
                  );


                if (
                  Number.isNaN(
                    index
                  )
                ) {
                  return;
                }


                goToSlide(
                  index
                );

              }
            );

          }
        );


        /* =================================================
           PAGE VISIBILITY
        ================================================== */

        document.addEventListener(
          'visibilitychange',
          function () {

            if (
              document.hidden
            ) {

              stopAutoplay();

            } else {

              startAutoplay();

            }

          }
        );


        /* =================================================
           SHOPIFY BLOCK SELECT

           Clicking a slide inside Theme Editor
           switches directly to that slide.
        ================================================== */

        banner.addEventListener(
          'shopify:block:select',
          function (event) {

            const slide =
              event.target.closest?.(
                '[data-hero-slide]'
              );


            if (!slide) {
              return;
            }


            const index =
              slides.indexOf(
                slide
              );


            if (
              index === -1
            ) {
              return;
            }


            stopAutoplay();


            if (
              index !== currentIndex
            ) {

              goToSlide(
                index
              );

            }

          }
        );


        /* =================================================
           INITIAL STATE
        ================================================== */

        slides.forEach(
          function (slide, index) {

            resetSlide(
              slide
            );


            slide.classList.toggle(
              'is-active',
              index === currentIndex
            );

          }
        );


        updateDots();

        startAutoplay();

      }
    );

  }


  /* =======================================================
     NORMAL PAGE LOAD
  ======================================================= */

  if (
    document.readyState ===
    'loading'
  ) {

    document.addEventListener(
      'DOMContentLoaded',
      function () {

        initHeroBanner();

      }
    );

  } else {

    initHeroBanner();

  }


  /* =======================================================
     SHOPIFY SECTION LOAD
  ======================================================= */

  document.addEventListener(
    'shopify:section:load',
    function (event) {

      const banner =
        event.target.matches?.(
          '[data-hero-banner]'
        )
          ? event.target
          : event.target.querySelector?.(
              '[data-hero-banner]'
            );


      if (!banner) {
        return;
      }


      delete banner.dataset
        .heroBannerInitialized;


      initHeroBanner(
        banner
      );

    }
  );

})();